import { render, staticRenderFns } from "./BackHeader.vue?vue&type=template&id=33923bbe&scoped=true&"
import script from "./BackHeader.vue?vue&type=script&lang=js&"
export * from "./BackHeader.vue?vue&type=script&lang=js&"
import style0 from "./BackHeader.vue?vue&type=style&index=0&id=33923bbe&lang=scss&scoped=true&"
import style1 from "./BackHeader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33923bbe",
  null
  
)

export default component.exports